import {CheckBox, Text, Flex, Title} from '@priority-software/priority-style-react';
import React, {useContext, useMemo} from 'react';
import {getLocalizedText, texts} from '../../../constants/TextConst';

import {AppSearchesContext} from '../AppSearchesContext';
import FilterList from './FiltersList';
import styles from './styles.module.scss';

const Conditions = () => {
    return (
        <Flex
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            componentClasses={styles.conditionBox}
        >
            <Flex
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                componentClasses={styles.condtionsTitleWrapper}
            >
                <Title textColor="primary-700" skin="h4" componentClasses={styles.condtionsTitle}>
                    {getLocalizedText(texts.Conditions)}
                </Title>
                <IgnoreCaseButton />
            </Flex>
            <Flex
                componentClasses={styles.content}
                justifyContent="flex-start"
                alignItems="flex-start"
                direction="column"
            >
                <FilterList />
            </Flex>
        </Flex>
    );
};

const IgnoreCaseButton = () => {
    const {search, handleUpdateIgnoreCase} = useContext(AppSearchesContext);
    return useMemo(
        () => (
            <Flex
                direction="row"
                justifyContent="space-between"
                componentClasses={styles.ignoreCaseWrapper}
            >
                <CheckBox
                    componentClasses={styles.ignorCase}
                    onChange={handleUpdateIgnoreCase}
                    checked={search.ignoreCase}
                >
                    <Text textColor="primary-700" skin="paragraph-2">
                        {getLocalizedText(texts.ignorecase)}
                    </Text>
                </CheckBox>
                <Text skin="label-1">{getLocalizedText(texts.sortHint)}</Text>
            </Flex>
        ),
        [search.ignoreCase, handleUpdateIgnoreCase]
    );
};
export default Conditions;
